module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-data"
  }, [_c('div', {
    staticClass: "bar-data border-right"
  }, [_vm._v("Pedido No. " + _vm._s(_vm.id))]), _vm._v(" "), _c('div', {
    staticClass: "bar-data border-right"
  }, [_vm._v("Comprado el " + _vm._s(_vm.formatDate))]), _vm._v(" "), _c('div', {
    staticClass: "bar-data"
  }, [_vm._v("Total: " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e2d2e6e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-data.vue
// module id = 1114
// module chunks = 2